<template>
  <div id="app">

    <header id="header">
      <div id="navbar"  >
        <Navbar />
      </div>
    </header>
    
    <main id="main" style="margin-top: 50px;">
      <router-view />
    </main>

    <Sidebar></Sidebar>

    <footer > 
      <FooterComponent />
    </footer>
	
  </div>
</template>

<script>
import Navbar from '@/components/NavbarComponent.vue';
import Sidebar from '@/components/SidebarComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default {
  name: 'App',
  components: {
    Navbar,
    Sidebar,
    FooterComponent
  },
  async mounted() {
    if (!this.$store.getters.getDataIsLoaded) {
      //await this.$store.dispatch('fetchSettings');
      await this.$store.dispatch('fetchParcels');
    }
  }
};
</script>

<style>

html, body { height: 100%; margin: 0; }

#app {
  text-align: center;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

:root { --footer-h: 124px; } /* hauteur du footer */

#main { padding-bottom: var(--footer-h) } /* var(--footer-h) */

footer {
  position: fixed; left: 0; right: 0; bottom: 0;
  height: var(--footer-h);
}

</style>
